import React from "react";
import { FaApple } from "react-icons/fa6";
import "./Home.css";
import HomeCard from "./HomeCard";

const Home = () => {
  return (
    <div name="home" className="home">
      <div className="appName">
        <h1 className="gradient-text">
          Instapaw
        </h1>
      </div>
      <div className="container">
        <div className="top">
          <h1>Every animal deserves a chance to be rescued.</h1>
        </div>

        <div id="download" className="download-panel" aria-label="Download Instapaw app">
          <p className="download-panel__eyebrow">Rescue starts with one tap</p>
          <div className="hero-download">
            <a
              className="store-button store-button--apple"
              href="https://apps.apple.com/in/app/instapaw/id6764773428"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaApple className="store-button-icon" aria-hidden="true" />
              <span>
                <small>Download on the</small>
                App Store
              </span>
            </a>
            <a
              className="store-button store-button--play"
              href="https://play.google.com/store/apps/details?id=com.santoshbhatt.instapaw"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className="store-button-icon store-button__play-icon"
                src="https://www.gstatic.com/images/branding/product/2x/play_prism_512dp.png"
                alt=""
                aria-hidden="true"
              />
              <span>
                <small>GET IT ON</small>
                Google Play
              </span>
            </a>
          </div>
        </div>

        <div className="card-content">
          <HomeCard
            title={"An animal rescue app \n built for people who want to act fast."}
            text={"Discover how Instapaw helps with stray dog rescue, cat rescue, pet adoption, missing pet recovery, feeder coordination, and local animal welfare across India. \n Use one animal rescue app to connect rescuers, NGOs, vets, feeders, and animal lovers around a case faster."}

            // backTitle="Be someone's smile, be someone's life"
            // backText="Animal deserves to exist without suffering, regardless of whether it 'belongs' to a human."
          />
        </div>
      </div>
    </div>
  );
};

export default Home;